import { NextPage } from "next";

import { deserializeProps } from "src/utilities/ssr/superjson";

export function withPropsDeserialization(
  PageComponent: NextPage<any>
): NextPage<any> {
  const Wrapped: NextPage<any> = (props) => {
    const deserializedProps =
      props?.json && props?.meta ? deserializeProps(props) : props;

    return <PageComponent {...deserializedProps} />;
  };

  return Wrapped;
}
